import { I9StepBase } from './I9Step';
import { BaseStepProps } from './BaseStepProps';

const I9SpanishStep = (props: BaseStepProps) => <I9StepBase {...props} spanish />;

export default I9SpanishStep;
